<template>
  <v-row>
    <v-col cols="12">
      <v-dialog v-model="dialog" persistent max-width="380px">
        <v-card>
          <v-form ref="form" lazy-validation>
            <v-card-title>
              <span>Next Call Date</span>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" class="mt-0 pt-0">
                    <v-menu
                      v-model="dateMenu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="selectedDate"
                          label="Select Date"
                          append-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="selectedDate"
                        @input="dateMenu = false"
                        :min="minDate"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>

                  <v-col cols="12" class="mt-0 pt-0">
                    <v-select
                      :items="reasons"
                      label="Select Reason*"
                      :rules="rules.required"
                      v-model="form.reason"
                    ></v-select>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions class="pb-5">
              <v-spacer></v-spacer>

              <v-btn @click.native="cancel" text> Cancel </v-btn>
              <v-btn @click.native="agree" color="primary"> Proceed </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      resolve: null,
      reject: null,
      // snackbar: false,
      // responseMessage: "",
      rules: {
        required: [(value) => !!value || "Required."],
      },

      form: {
        reason: "",
      },

      reasons: ["NO RESPONSE", "UNCONTACTED", "CLIENT REQUEST RESCHEDULE"],
      selectedDate: new Date().toISOString().split("T")[0],
      dateMenu: false,
      minDate: new Date().toISOString().split("T")[0],
    };
  },
  // props: ["data", "dialog", "apiUrl", "title"],

  methods: {
    async open() {
      this.dialog = true;
      // this.currentData = data;
      // this.getReasons();
      this.form.reason = "";
      // this.form.dealerName = data.companyName;
      // this.title = title;
      // this.message = message;
      // this.options = Object.assign(this.options, options);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    agree() {
      this.resolve({
        status: true,
        data: {
          reason: this.form.reason,
          date: this.selectedDate,
        },
      });
      this.dialog = false;
    },

    cancel() {
      this.resolve({
        status: false,
      });
      this.dialog = false;
    },
    // closeDialog() {
    //   this.$emit("close", false);
    // },
  },

  watch: {},
};
</script>
